import { Outlet, useLocation } from 'react-router-dom'

import { ChainRail, GlossaryProvider } from '../ui'
import { Sidebar } from './Sidebar'
import styles from './AppShell.module.css'

export function AppShell() {
  const location = useLocation()

  return (
    <div className={styles.app}>
      <Sidebar />
      <main className={styles.main}>
        <GlossaryProvider scopeKey={location.key}>
          <ChainRail key={location.key} />
          <div className={styles.wrap}><Outlet /></div>
        </GlossaryProvider>
      </main>
    </div>
  )
}
